import { render, staticRenderFns } from "./RequestProblemBar.vue?vue&type=template&id=6f07306a&scoped=true"
import script from "./RequestProblemBar.vue?vue&type=script&lang=js"
export * from "./RequestProblemBar.vue?vue&type=script&lang=js"
import style0 from "./RequestProblemBar.vue?vue&type=style&index=0&id=6f07306a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07306a",
  null
  
)

export default component.exports